import Footer from "@/components/basic/Footer";
import {ScrollView, View} from "react-native";
import {VStack} from "@/components/ui/vstack";
import {Text} from "@/components/ui/text";
import i18n from "i18n-js";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useSafeAreaInsets} from "react-native-safe-area-context";
import {FlatList} from "react-native-gesture-handler";
import ContactElement from "@/components/basic/ContactElement";
import {backendRequest} from "@/stores/thunks";
import {switchScreen} from "@/hooks/navigate";

export default function RequestPlanning({navigation}){

    const contacts = useSelector((state) => state.contacts.active)
    const server = useSelector((state) => state.server)
    const insets = useSafeAreaInsets()
    const paddingBottom = (server.online ? 140 : 90) + insets.bottom;
    const dispatch = useDispatch();

    const [selectedContacts, setSelectedContacts] = useState([]);

    const toggleSelectContact = (contactId, _) => {
        setSelectedContacts(!selectedContacts.includes(contactId)
            ? prev => {
                return [...prev, contactId];
            } : prev => {
                return prev.filter(id => id !== contactId);
            }
        )
    }

    const renderItem = ({ item, index }) => {
            return <ContactElement
                key={'A' + index}
                uri={item?.contactImage?.id || item.toUser.id}
                title={item.contactAlias || item.toUser.mail} text={item.toUser.preferredName}
                onPress={toggleSelectContact}
                id={item.id}
                selected={selectedContacts.includes(item.id)}
            />
    }

    const onSend = () => {
        dispatch(backendRequest('PLANNER_REQUEST', '/contact/planner', {contacts: selectedContacts}, 'POST', false))
        .then(() => {
            switchScreen(navigation, 'BACK')
        })

    }

    /**
     * @param {Contact} contact
     */
    const planningNotAllowedOrRequested = (contact) => {
        return !contact.planningForAllowed && contact.planningRequestTo === null;

    }

    return (

        <View className="flex-1 bg-secondary-50">
            <FlatList
                data={contacts.filter(contact => planningNotAllowedOrRequested(contact))}
                keyExtractor={(item, index) => (item.id || 'T') + index}
                renderItem={renderItem}
                contentContainerStyle={{
                    paddingBottom: paddingBottom + 70,
                    paddingHorizontal: 12,
                    paddingTop: 12,
                }}
                ListHeaderComponent={
                    <Text className="text-2xl font-normal text-secondary-900 mb-4">
                        {i18n.t('plannerRequest.contactsLeft', {
                            num: contacts.filter(contact => planningNotAllowedOrRequested(contact)).length
                        })}
                    </Text>
                }
            />
            <Footer navigation={navigation} button={{
                disabled: selectedContacts.length === 0,
                info: 'plannerRequest.sendRequest',
                action: onSend
            }}/>
        </View>
    )
}
